import React, { useState, useCallback } from "react";

import { Grid, Typography, useTheme, Divider, Box, Card, CardContent, CardHeader, MenuItem, Select, Checkbox, IconButton, TextField, Button, Tooltip, Chip } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useRef } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    InputLabel, FormControl
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import ShoppingCartCheckoutOutlinedIcon from '@mui/icons-material/ShoppingCartCheckoutOutlined';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';
import ScatterPlotOutlinedIcon from '@mui/icons-material/ScatterPlotOutlined';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddIcon from '@mui/icons-material/Add';
import AddCircle from '@mui/icons-material/AddCircle';
import { tokens } from "../../theme/theme";
import { keyframes } from '@mui/system';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import CallAlertBar from "../../Layout/Alertbar";
import FilterCutterType from "../../pages/commonvalidations/cuttertype";


import { callApi } from "../../pages/commonapicall/fetchdata";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const MachineParametersSettings = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [editRows, setEditRows] = useState({});
    const [expandedRows, setExpandedRows] = useState({});



    const [duplexexpandedRows, setDuplexExpandedRows] = useState({});
    const [simplexexpandedRows, setSimplexExpandedRows] = useState({});



    // Sample rows
    const machinedetail = [
        {
            id: 1,
            machineCode: 'MC001',
            machineName: 'Machine A',
            minDeckleWidth: 100,
            maxDeckleWidth: 200,
            maxNoOfCircularKnives: 10,
            minWeightPerCombination: 50,
            minDiameter: 30,
            maxDiameter: 100,
            minGsmOnMc: 50,
            maxGsmOnMc: 300,
            jumboRollWidth: 150,
            defaultSimplexMachine: 'Simplex 1',
            winderAllowancePerCut: 5,
            productionCapacity: 1000,
            timeToAddKnives: 10,
            timeToChangeKnives: 15,
            timeToRemoveKnife: 5,
            timeToChangeParentRoll: 20,
            selectitem: false,
        },
        {
            id: 2,
            machineCode: 'MC002',
            machineName: 'Machine B',
            minDeckleWidth: 280,
            maxDeckleWidth: 285,
            maxNoOfCircularKnives: 10,
            minWeightPerCombination: 50,
            minDiameter: 30,
            maxDiameter: 100,
            minGsmOnMc: 50,
            maxGsmOnMc: 300,
            jumboRollWidth: 150,
            defaultSimplexMachine: 'Simplex 2',
            winderAllowancePerCut: 5,
            productionCapacity: 1000,
            timeToAddKnives: 10,
            timeToChangeKnives: 15,
            timeToRemoveKnife: 5,
            timeToChangeParentRoll: 20,
            selectitem: false,
        },
        // Add more rows as needed
    ];

    const [winderDetail, setWinderDetail] = useState([]);
    const [selectedWinderMachines, setSelectedWinderMachines] = useState([]);

    const [duplexDetail, setDuplexDetail] = useState([]);
    const [selectedDuplexMachines, setSelectedDuplexMachines] = useState([]);

    const [simplexDetail, setSimplexDetail] = useState([]);
    const [selectedSimplexDetail, setSelectedSimplexDetail] = useState([]);
    const [selectedCutterType, setCutterType] = useState('Simplex'); // Default product category  
    const [visibleDuplex, setvisibleDuplex] = useState(true);
    const [visibleWinder, setvisibleWinder] = useState(true);
    const [visibleSimplex, setvisibleSimplex] = useState(true);
    const [refreshData, setRefreshData] = useState(false);

    const [machineList, setmachineList] = useState(machinedetail);
    const [deckleMatchingMsgOpen, setDeckleMatchingMsgOpen] = useState(false);
    const [deckleMatchingSeverityvalue, setDeckleMatchingSeverityvalue] = useState('info');
    const [deckleMatchingMessageValue, setDeckleMatchingMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [deckleMatchingAlertTitleValue, setDeckleMatchingAlertTitleValue] = useState('');

    const msg = (severityvalue, title, messageValue) => {
        setDeckleMatchingSeverityvalue(severityvalue);
        setDeckleMatchingMessageValue(messageValue);
        setDeckleMatchingAlertTitleValue(title);
        setDeckleMatchingMsgOpen(true);
    };


    const display_error = (error) => {
        setDeckleMatchingSeverityvalue('error');
        setDeckleMatchingMessageValue(error.message);
        setDeckleMatchingAlertTitleValue('Error');
        setDeckleMatchingMsgOpen(true);
    }


    useEffect(() => { LoadWinderMachineList(); }, []);

    useEffect(() => { LoadDuplexMachineList(); }, []);

    useEffect(() => { LoadSimplexMachineList(); }, []);


    const LoadWinderMachineList = useCallback(() => {
        const param = {
            p_companyid: localStorage.getItem('companyid'),
            p_cuttertype: 'Winder'
        };

        callApi(API_ENDPOINTS.DECKL_LOADWINDERLIST, 'POST', { 'Content-Type': 'application/json' }, param)
            .then(data => {
                if (data && Array.isArray(data) && data.length > 0) {
                    // Update state with fetched data


                    setWinderDetail(() => data); // Use functional update
                    setSelectedWinderMachines(() => data.filter(row => row.selectitem));
                }
            })
            .catch(error => {
                display_error(error);
            });
    }, []); // Add any dependencies like API_ENDPOINTS or callApi     


    const LoadDuplexMachineList = () => {
        const param = {
            p_companyid: localStorage.getItem('companyid'),
        }

        callApi(API_ENDPOINTS.DECKL_LOADDUPLEXLIST, 'POST', { 'Content-Type': 'application/json' }, param)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    const formattedData = data.map((row, index) => ({ ...row, id: row.machine_id }));
                    setDuplexDetail(formattedData);
                }

            })
            .catch(error => {
                display_error(error);
            });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const LoadSimplexMachineList = useCallback(() => {
        const param = {
            p_companyid: 1,
        }
        callApi(API_ENDPOINTS.DECKL_LOADSIMPLEXLIST, 'POST', { 'Content-Type': 'application/json' }, param)
            .then(data => {
                if (data && data.length > 0) {
                    if (data.length > 0) {
                        data[0].selectitem = true;
                    }

                    const formattedData = data.map((row) => ({ ...row, id: row.c_code }));
                    setSimplexDetail(formattedData);
                    setSelectedSimplexDetail(formattedData.filter(row => row.selectitem));
                }
            })
            .catch(error => {
                display_error(error);
            });
    });

    const filterCutterType = (filter) => {
        setCutterType(filter);
        setRefreshData(true);

        if (filter === 'duplex') {
            setvisibleDuplex(true);
            setvisibleWinder(false);
            setvisibleSimplex(false);
        }
        else {
            setvisibleDuplex(false);
            setvisibleWinder(true);
            setvisibleSimplex(true);
        }
    };


    // Define your delete function
    const handleDelete = async (id) => {
        // Confirm deletion with the user
        if (window.confirm('Are you sure you want to delete this machine?')) {
            try {
                const response = await fetch(API_ENDPOINTS.MASTER_Delete_Record, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(id)
                });

                if (response.ok) {
                    const result = await response.json();

                    if (result === 'Selected Winder deleted successfully..!') {
                        msg('info', 'Info', result);
                    }
                    else {
                        msg('error', 'Error', 'Unable to deleted winder details');
                    }
                    LoadWinderMachineList();
                } else {
                    const errorData = await response.json();
                    msg('error', 'Error', `Failed to delete record: ${errorData.message || response.statusText}`);
                }
            } catch (error) {
                console.error('Failed to delete record', error);
                msg('error', 'Error', 'An unexpected error occurred while saving machine data');
            }
        }
    };

    // Define your delete function for simplex cutter
    const handleDeleteSimplex = async (id) => {
        // Confirm deletion with the user
        if (window.confirm('Are you sure you want to delete this cutter?')) {
            try {
                const response = await fetch(API_ENDPOINTS.MASTER_Delete_Record_simplex, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(id)
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result === 'Selected Simplex deleted successfully..!') {
                        msg('info', 'Info', result);
                    }
                    else {
                        msg('error', 'Error', 'Unable to delete the simplex details');
                    }
                    LoadSimplexMachineList();
                } else {
                    const errorData = await response.json();
                    msg('error', 'Error', `Failed to delete record: ${errorData.message || response.statusText}`);
                }
            } catch (error) {
                console.error('Failed to delete record', error);
                msg('error', 'Error', 'An unexpected error occurred while saving machine data');
            }
        }
    };


    const handleDeleteDuplex = async (id) => {
        // Confirm deletion with the user
        if (window.confirm('Are you sure you want to delete this duplex cutter?')) {
            try {
                const response = await fetch(API_ENDPOINTS.MASTER_Delete_Record_duplex, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(id)
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result === 'Selected Duplex deleted successfully..!') {
                        msg('info', 'Info', result);
                    }
                    else {
                        msg('error', 'Error', 'Unable to delete the Duplex details');
                    }
                    LoadDuplexMachineList();
                } else {
                    const errorData = await response.json();
                    msg('error', 'Error', `Failed to delete record: ${errorData.message || response.statusText}`);
                }
            } catch (error) {
                console.error('Failed to delete record', error);
                msg('error', 'Error', 'An unexpected error occurred while saving machine data');
            }
        }
    };


    const columns = [
        { field: 'machine_name', headerName: 'Machine Name', width: 120 },
        { field: 'mindeckle', headerName: 'Min Deckle Width', type: 'number', width: 120 },
        { field: 'maxdeckle', headerName: 'Max Deckle Width', type: 'number', width: 120 },
        { field: 'maxcircularknife', headerName: 'Max Knives', type: 'number', width: 100 },
        { field: 'minsetweight', headerName: 'Min Set weight', type: 'number', width: 120 },
        { field: 'jumborollwidth', headerName: 'Jumbo Roll Width', type: 'number', width: 100 },
        { field: 'productioncapacity', headerName: 'Production Capacity', type: 'number', width: 120 },


        {
            field: 'details',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 150,
            renderCell: (params) => (
                <>
                    <IconButton
                        onClick={() => handleExpandClick(params.row.id)}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton
                        //  color="error"  // Optional: Sets the color of the delete button to red
                        onClick={() => handleDelete(params.row.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </>
            ),
        },
    ];


    const handleExpandClick = (id) => {
        setIsAddingNewRow(false);
        setOpenWinderEdit(true);
        setExpandedRows({});
        setExpandedRows(prevExpandedRows => ({
            ...prevExpandedRows,
            [id]: !prevExpandedRows[id],
        }));
    };



    const handleSelectAllCheckboxChange = (event) => {
        let updatedRows = winderDetail.map(row => ({ ...row, selectitem: event.target.checked }));
        setWinderDetail(updatedRows);
        setSelectedWinderMachines(event.target.checked ? updatedRows : []);
    };

    const areAllRowsSelected = () => {
        return winderDetail.every(row => row.selectitem);
    };

    const handleCheckboxChange = (event, rowId) => {
        const updatedRows = winderDetail.map(row =>
            row.id === rowId ? { ...row, selectitem: event.target.checked } : row
        );
        setWinderDetail(updatedRows);
        setSelectedWinderMachines(updatedRows.filter(row => row.selectitem));
    };

    const handleSelectChange = (id, value) => {
        const updatedRows = winderDetail.map(row =>
            row.id === id ? { ...row, defaultSimplexMachine: value } : row
        );
        setWinderDetail(updatedRows);
    };




    const handleEditClick = async (id) => {
        if (editRows[id]) {
            // Save logic here
            const editedRow = winderDetail.find(row => row.id === id);
            await handleSaveOrEditRow(true, editedRow)
        }

        setEditRows(prev => ({
            ...prev,
            [id]: !prev[id], // Toggle edit state
        }));
    };

    const handleEditClickSimplex = async (id) => {
        if (editRows[id]) {
            // Save logic here
            const editedRow = simplexDetail.find(row => row.id === id);
            await handleSaveOrEditRowSimplex(true, editedRow)
        }

        setEditRows(prev => ({
            ...prev,
            [id]: !prev[id], // Toggle edit state
        }));
    };

    const handleEditClickDuplex = async (id) => {
        if (editRows[id]) {
            // Save logic here
            const editedRow = duplexDetail.find(row => row.id === id);
            await handleSaveOrEditRowDuplex(true, editedRow)
        }

        setEditRows(prev => ({
            ...prev,
            [id]: !prev[id], // Toggle edit state
        }));
    };

    const handleEditChange = (id, field, value) => {
        setWinderDetail(prevDetails =>
            prevDetails.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };


    const handleEditChangeSimplex = (id, field, value) => {
        setSimplexDetail(prevDetails =>
            prevDetails.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const handleEditChangeDuplex = (id, field, value) => {
        setDuplexDetail(prevDetails =>
            prevDetails.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };


    // duplex columns
    const Duplexcolumns = [

        { field: 'machine_name', headerName: 'Machine Name', width: 200 },
        { field: 'mindeckle', headerName: 'Min Deckle Width', type: 'number', width: 150 },
        { field: 'maxdeckle', headerName: 'Max Deckle Width', type: 'number', width: 150 },
        { field: 'maxcircularknife', headerName: 'Max Kinves', type: 'number', width: 100 },
        { field: 'jumborollwidth', headerName: 'Jumbo Width', type: 'number', width: 100 },
        { field: 'minsetweight', headerName: 'Min Weight per Combination', type: 'number', width: 200 },



        {
            field: 'details',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 100,
            renderCell: (params) => (
                <>
                    <IconButton
                        onClick={() => handleDuplexExpandClick(params.row.id)}
                    >
                        {params.row.expand ? <EditIcon /> : <EditIcon />}
                    </IconButton>

                    <IconButton
                        onClick={() => handleDeleteDuplex(params.row.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </>
            ),
        },
    ];

    const handleDuplexExpandClick = (id) => {
        setIsAddingNewRowDuplex(false);
        setOpenDuplexEdit(true);

        setDuplexExpandedRows({});
        setDuplexExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleDuplexSelectAllCheckboxChange = (event) => {
        let updatedRows = duplexDetail.map(row => ({ ...row, selectitem: event.target.checked }));
        setmachineList(updatedRows);
        setSelectedDuplexMachines(event.target.checked ? updatedRows : []);
    };

    const areDuplexAllRowsSelected = () => {
        return duplexDetail.every(row => row.selectitem);
    };

    const handleDuplexCheckboxChange = (event, rowId) => {
        const updatedRows = duplexDetail.map(row =>
            row.id === rowId ? { ...row, selectitem: event.target.checked } : row
        );
        setmachineList(updatedRows);
        setSelectedDuplexMachines(updatedRows.filter(row => row.selectitem));
    };   

    // duplex columns
    const Simplexcolumns = [

        { field: 'c_name', headerName: 'Machine Name', width: 200 },
        { field: 'c_width_min', headerName: 'Min Deckle Width', type: 'number', width: 100 },
        { field: 'c_width', headerName: 'Max Deckle Width', type: 'number', width: 100 },
        { field: 'c_knives', headerName: 'Max Knives', type: 'number', width: 100 },
        { field: 'allow_per_cut', headerName: 'Allowance per cut', type: 'number', width: 100 },
        { field: 'min_dia', headerName: 'Min Diameter', type: 'number', width: 100 },
        { field: 'max_dia', headerName: 'Max Diameter', type: 'number', width: 100 },
        { field: 'min_cutter_load', headerName: 'Min Cutter load', type: 'number', width: 100 },
        { field: 'max_cutter_load', headerName: 'Max Cutter load', type: 'number', width: 100 },
        
       
        {
            field: 'details',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 100,
            renderCell: (params) => (
                <>
                    <IconButton
                        onClick={() => handleSimplexExpandClick(params.row.id)}
                    >
                        {params.row.expand ? <EditIcon /> : <EditIcon />}
                    </IconButton>



                    <IconButton
                        //  color="error"  // Optional: Sets the color of the delete button to red
                        onClick={() => handleDeleteSimplex(params.row.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </>

            ),
        },
    ];

    const handleSimplexExpandClick = (id) => {
        setIsAddingNewRowSimplex(false);
        setOpenSimplexEdit(true);
        setSimplexExpandedRows({});
        setSimplexExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleSimplexSelectAllCheckboxChange = (event) => {
        let updatedRows = simplexDetail.map(row => ({ ...row, selectitem: event.target.checked }));
        setSimplexDetail(updatedRows);
        setSelectedSimplexDetail(event.target.checked ? updatedRows : []);
    };

    const areSimplexAllRowsSelected = () => {
        return simplexDetail.every(row => row.selectitem);
    };

    const handleSimplexCheckboxChange = (event, rowId) => {
        const updatedRows = simplexDetail.map(row =>
            row.id === rowId ? { ...row, selectitem: event.target.checked } : row
        );
        setSimplexDetail(updatedRows);
        setSelectedSimplexDetail(updatedRows.filter(row => row.selectitem));
    };




    const [selectedChip, setSelectedChip] = useState('Winder Machine Parameters');

    const handleChipClick = (chipName, setShowFunction) => {
        setSelectedChip(chipName);
        setShowFunction();
    };

    const iconStyle = {
        fontSize: '24px', // Ensure all icons have the same size
    };

    const selectedChipStyle = {
        borderColor: 'transparent',
        borderWidth: '0.5px',
        borderStyle: 'solid',
        backgroundColor: colors.blueAccent[200],
        // borderColor: '#2196F3',
        color: colors.blueAccent[900]
    };
    const unselectedChipStyle = {

        borderColor: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: colors.primary[400],
        color: 'white',
    };

    const [viewWinderDetail, setViewWinderDetail] = useState(true);
    const [viewDuplexDetail, setViewDuplexDetail] = useState(false);
    const [viewSimplexDetail, setViewSimplexDetail] = useState(false);

    const handleViewWinderDetails = () => {
        setViewWinderDetail(true);
        setViewDuplexDetail(false);
        setViewSimplexDetail(false);
    };


    const handleViewDuplexDetails = () => {
        setViewWinderDetail(false);
        setViewDuplexDetail(true);
        setViewSimplexDetail(false);
    };

    const handleViewSimplexDetails = () => {
        setViewWinderDetail(false);
        setViewDuplexDetail(false);
        setViewSimplexDetail(true);
    };



    const [newRowData, setNewRowData] = useState({
        machine_name: '',
        machine_code: '',
        mindeckle: '',
        maxdeckle: '',
        maxcircularknife: '',
        minsetweight: '',
        mindiameter: '',
        maxdiameter: '',
        mingsm: '',
        maxgsm: '',
        jumborollwidth: '',
        allowance_per_cut: '',
        cutter: '',
        production_capacity: '',
        tr_addknife: '',
        tr_changeknife: '',
        tr_changeparentroll: '',
        tr_removeknife: '',

    });

    const [newRowDataSimplex, setNewRowDataSimplex] = useState({
        c_name: '',
        c_width: '',
        c_width_min: '',
        c_knives: '',
        allow_per_cut: '',
        min_chopping_size: '',
        max_chopping_size: '',
        min_dia: '',
        max_dia: '',
        max_no_of_parent_cut: '',
        min_cutter_load: '',
        max_cutter_load: '',
        cutter_allowance: '',
        allow_trim_for_single_packet: false,
        min_chopping_size_for_single_packet_trim: ''
    });

    const [newRowDataDuplex, setNewRowDataDuplex] = useState({
        machine_no: '',
        machine_name: '',
        mindeckle: '',
        maxdeckle: '',
        maxcircularknife: '',
        max_diff_btwn_both_chop_sze: '',
        max_width_st1: '',
        max_slit_per_cut: '',
        min_chopping_st1: '',
        min_chopping_st2: '',
        jumborollwidth: '',
        minsetweight: ''
    });


    const [isAddingNewRow, setIsAddingNewRow] = useState(false);
    const [isAddingNewRowSimplex, setIsAddingNewRowSimplex] = useState(false);
    const [isAddingNewRowDuplex, setIsAddingNewRowDuplex] = useState(false);

    const handleNewRowChange = (field, value) => {
        setNewRowData(prevData => ({ ...prevData, [field]: value }));
    };
    const handleNewRowChangeSimplex = (field, value) => {
        setNewRowDataSimplex(prevData => ({ ...prevData, [field]: value }));
    };

    const handleNewRowChangeDuplex = (field, value) => {
        setNewRowDataDuplex(prevData => ({ ...prevData, [field]: value }));
    };

    const handleSaveOrEditRow = useCallback(async (isEdit = false, updatedRow = null) => {
        const dataToSave = isEdit ? updatedRow : newRowData;

        // Validation
        const requiredFields = ['machine_name', 'mindeckle', 'maxdeckle', 'maxcircularknife', 'minsetweight', 'mindiameter', 'maxdiameter', 'jumborollwidth'];
        const specificField = isEdit ? 'machine_no' : 'machine_code';

        if (!dataToSave[specificField] || requiredFields.some(field => !dataToSave[field])) {
            msg('error', 'Error', 'Please fill all required fields');
            return;
        }

        if (parseFloat(dataToSave.maxdeckle) < parseFloat(dataToSave.mindeckle)) {
            msg('error', 'Validation Error', 'Max deckle should be greater than or equal to Min deckle');
            return;
        }

        if (parseFloat(dataToSave.maxdiameter) < parseFloat(dataToSave.mindiameter)) {
            msg('error', 'Validation Error', 'Max diameter should be greater than or equal to Min diameter');
            return;
        }

        if (parseFloat(dataToSave.jumborollwidth) < parseFloat(dataToSave.maxdeckle)) {
            msg('error', 'Validation Error', 'Jumbo roll width should be greater than or equal to Max deckle');
            return;
        }

        if (parseFloat(dataToSave.maxgsm) < parseFloat(dataToSave.mingsm)) {
            msg('error', 'Validation Error', 'Max GSM should be greater than or equal to Min GSM');
            return;
        }

        try {
            const requestBody = {
                filter: { p_companyid: 1 }, // Example value for company ID
                winderMachineList: [{
                    machine_no: isEdit ? dataToSave.machine_no : dataToSave.machine_code,
                    machine_name: dataToSave.machine_name,
                    mindeckle: parseFloat(dataToSave.mindeckle),
                    maxdeckle: parseFloat(dataToSave.maxdeckle),
                    maxcircularknife: parseInt(dataToSave.maxcircularknife),
                    minsetweight: parseFloat(dataToSave.minsetweight),
                    mindiameter: parseFloat(dataToSave.mindiameter),
                    maxdiameter: parseFloat(dataToSave.maxdiameter),
                    mingsm: parseFloat(dataToSave.mingsm),
                    maxgsm: parseFloat(dataToSave.maxgsm),
                    jumborollwidth: parseFloat(dataToSave.jumborollwidth),
                    allowance_per_cut: parseFloat(dataToSave.allowance_per_cut),
                    cutter: dataToSave.cutter,
                    production_capacity: parseFloat(dataToSave.production_capacity),
                    tr_addknife: parseFloat(dataToSave.tr_addknife),
                    tr_changeknife: parseFloat(dataToSave.tr_changeknife),
                    tr_changeparentroll: parseFloat(dataToSave.tr_changeparentroll),
                    tr_removeknife: parseFloat(dataToSave.tr_removeknife),
                    ...(isEdit && { machine_id: dataToSave.machine_id })
                }]
            };

            const response = await fetch(API_ENDPOINTS.MASTER_Add_update_winderdetails, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const result = await response.json();
                msg('info', 'Info', `Winder machine ${isEdit ? 'updated' : 'created'} Successfully`);

                LoadWinderMachineList();

                if (!isEdit) {
                    setIsAddingNewRow(false);
                    setNewRowData({
                        machine_code: '',
                        machine_name: '',
                        mindeckle: '',
                        maxdeckle: '',
                        maxcircularknife: '',
                        minsetweight: '',
                        mindiameter: '',
                        maxdiameter: '',
                        mingsm: '',
                        maxgsm: '',
                        jumborollwidth: '',
                        allowance_per_cut: '',
                        cutter: '',
                        production_capacity: '',
                        tr_addknife: '',
                        tr_changeknife: '',
                        tr_changeparentroll: '',
                        tr_removeknife: '',
                        machine_id: ''
                    });
                }
            } else {
                const errorData = await response.json();
                msg('error', 'Error', `Error saving machine data: ${errorData.message || response.statusText}`);
            }
        } catch (error) {
            console.error('Error saving machine data', error);
            msg('error', 'Error', 'An unexpected error occurred while saving machine data');
        }
    }, [newRowData, LoadWinderMachineList]);

    const handleSaveOrEditRowSimplex = useCallback(async (isEdit = false, updatedRow = null) => {
        const dataToSave = isEdit ? updatedRow : newRowDataSimplex;

        // Validation
        const requiredFields = ['c_name', 'c_width', 'c_width_min', 'c_knives', 'min_chopping_size', 'max_chopping_size', 'min_dia', 'max_dia', 'max_no_of_parent_cut', 'min_cutter_load', 'max_cutter_load'];

        if (requiredFields.some(field => !dataToSave[field])) {
            msg('error', 'Error', 'Please fill all required fields');
            return;
        }

        if (parseFloat(dataToSave.c_width) < parseFloat(dataToSave.c_width_min)) {
            msg('error', 'Validation Error', 'Max deckle should be greater than or equal to Min deckle');
            return;
        }

        if (parseFloat(dataToSave.max_dia) < parseFloat(dataToSave.min_dia)) {
            msg('error', 'Validation Error', 'Max diameter should be greater than or equal to Min diameter');
            return;
        }

        if (parseFloat(dataToSave.max_chopping_size) < parseFloat(dataToSave.min_chopping_size)) {
            msg('error', 'Validation Error', 'Max Chopping should be greater than or equal to Min Chopping');
            return;
        }
        if (parseFloat(dataToSave.max_cutter_load) < parseFloat(dataToSave.min_cutter_load)) {
            msg('error', 'Validation Error', 'Max cutter load should be greater than or equal to Min cutter load');
            return;
        }

        try {
            const requestBody = {
                Filter: { p_companyid: 1 }, // Example value for company ID
                SimplexList: [{
                    c_name: dataToSave.c_name,
                    c_width: parseFloat(dataToSave.c_width),
                    c_width_min: parseFloat(dataToSave.c_width_min),
                    c_knives: parseInt(dataToSave.c_knives),
                    allow_per_cut: parseFloat(dataToSave.allow_per_cut),
                    min_chopping_size: parseFloat(dataToSave.min_chopping_size),
                    max_chopping_size: parseFloat(dataToSave.max_chopping_size),
                    min_dia: parseFloat(dataToSave.min_dia),
                    max_dia: parseFloat(dataToSave.max_dia),
                    max_no_of_parent_cut: parseInt(dataToSave.max_no_of_parent_cut),
                    min_cutter_load: parseFloat(dataToSave.min_cutter_load),
                    max_cutter_load: parseFloat(dataToSave.max_cutter_load),
                    cutter_allowance: parseFloat(dataToSave.cutter_allowance),
                    allow_trim_for_single_packet: (dataToSave.allow_trim_for_single_packet),
                    min_chopping_size_for_single_packet_trim: parseFloat(dataToSave.min_chopping_size_for_single_packet_trim),
                    ...(isEdit && { c_code: dataToSave.c_code })
                }]
            };

            const response = await fetch(API_ENDPOINTS.MASTER_Add_update_simplexdetails, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const result = await response.json();
                msg('info', 'Info', `Simplex cutter ${isEdit ? 'updated' : 'created'} Successfully`);


                LoadSimplexMachineList();

                if (!isEdit) {
                    setIsAddingNewRowSimplex(false);
                    setNewRowDataSimplex({
                        c_name: '',
                        c_width: '',
                        c_width_min: '',
                        c_knives: '',
                        allow_per_cut: '',
                        min_chopping_size: '',
                        max_chopping_size: '',
                        min_dia: '',
                        max_dia: '',
                        max_no_of_parent_cut: '',
                        min_cutter_load: '',
                        max_cutter_load: '',
                        cutter_allowance: '',
                        allow_trim_for_single_packet: false,
                        min_chopping_size_for_single_packet_trim: ''
                    });
                }
            } else {
                const errorData = await response.json();
                msg('error', 'Error', `Error saving machine data: ${errorData.message || response.statusText}`);
            }
        } catch (error) {
            console.error('Error saving machine data', error);
            msg('error', 'Error', 'An unexpected error occurred while saving machine data');
        }
    }, [newRowDataSimplex, LoadSimplexMachineList]);

    const handleSaveOrEditRowDuplex = useCallback(async (isEdit = false, updatedRow = null) => {
        const dataToSave = isEdit ? updatedRow : newRowDataDuplex;

        // Validation
        const requiredFields = ['machine_no', 'machine_name', 'mindeckle', 'maxdeckle', 'maxcircularknife', 'jumborollwidth', 'minsetweight'];

        if (requiredFields.some(field => !dataToSave[field])) {
            msg('error', 'Error', 'Please fill all required fields');
            return;
        }

        if (parseFloat(dataToSave.maxdeckle) < parseFloat(dataToSave.mindeckle)) {
            msg('error', 'Validation Error', 'Max deckle should be greater than or equal to Min deckle');
            return;
        }

        if (parseFloat(dataToSave.jumborollwidth) < parseFloat(dataToSave.maxdeckle)) {
            msg('error', 'Validation Error', 'Jumbo roll width should be greater than or equal to Max diameter');
            return;
        }

        try {
            const requestBody = {
                Filter: { p_companyid: 1 }, // Example value for company ID
                DuplexList: [{
                    machine_no: dataToSave.machine_no,
                    machine_name: (dataToSave.machine_name),
                    mindeckle: parseFloat(dataToSave.mindeckle),
                    maxdeckle: parseFloat(dataToSave.maxdeckle),
                    maxcircularknife: parseInt(dataToSave.maxcircularknife),
                    max_diff_btwn_both_chop_sze: parseFloat(dataToSave.max_diff_btwn_both_chop_sze),
                    jumborollwidth: parseFloat(dataToSave.jumborollwidth),
                    minsetweight: parseFloat(dataToSave.minsetweight),
                    ...(isEdit && { c_code: dataToSave.machine_id })
                }]
            };

            const response = await fetch(API_ENDPOINTS.MASTER_Add_update_duplexdetails, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const result = await response.json();
                msg('info', 'Info', `Duplex cutter ${isEdit ? 'updated' : 'created'} Successfully`);

                LoadDuplexMachineList();

                if (!isEdit) {
                    setIsAddingNewRowDuplex(false);
                    setNewRowDataDuplex({
                        machine_no: '',
                        machine_name: '',
                        mindeckle: '',
                        maxdeckle: '',
                        maxcircularknife: '',
                        max_diff_btwn_both_chop_sze: '',
                        max_width_st1: '',
                        max_slit_per_cut: '',
                        min_chopping_st1: '',
                        min_chopping_st2: '',
                        jumborollwidth: '',
                        minsetweight: '',
                    });
                }
            } else {
                const errorData = await response.json();
                msg('error', 'Error', `Error saving machine data: ${errorData.message || response.statusText}`);
            }
        } catch (error) {
            console.error('Error saving machine data', error);
            msg('error', 'Error', 'An unexpected error occurred while saving machine data');
        }
    }, [newRowDataDuplex, LoadDuplexMachineList]);


    const handleNewButtonClick = () => {
        setIsAddingNewRow(true);
        setOpenWinder(true);
        setExpandedRows({});
        setOpenWinderEdit(false);
    };

    const handleNewButtonClickSimplex = () => {
        setIsAddingNewRowSimplex(true);
        setSimplexExpandedRows({});
        setOpenSimplex(true);
    };

    const handleNewButtonClickDuplex = () => {
        setIsAddingNewRowDuplex(true);
        setDuplexExpandedRows({});
        setOpenDuplex(true);
    };

    const [openWinder, setOpenWinder] = useState(false);
    const [openWinderEdit, setOpenWinderEdit] = useState(false);

    const [openSimplex, setOpenSimplex] = useState(false);
    const [openSimplexEdit, setOpenSimplexEdit] = useState(false);

    const [openDuplex, setOpenDuplex] = useState(false);
    const [openDuplexEdit, setOpenDuplexEdit] = useState(false);

    const handleCloseWinderDialog = () => {
        setOpenWinder(false);
    };

    const handleCloseWinderEditDialog = () => {
        setOpenWinderEdit(false);
    };

    const handleCloseSimplexDialog = () => {
        setOpenSimplex(false);
    };

    const handleCloseSimplexEditDialog = () => {
        setOpenSimplexEdit(false);
    };

    const handleCloseDuplexDialog = () => {
        setOpenDuplex(false);
    };

    const handleCloseDuplexEditDialog = () => {
        setOpenDuplexEdit(false);
    };



    return (
        <>
            <Grid container padding={1} >
                <Grid item md={0} marginRight={1}>
                    <Box sx={{ backgroundColor: "brown", padding: "4px", borderRadius: "10px", width: "160px", display: 'flex', alignItems: 'center' }}>
                        {/* sx={{ backgroundColor: "brown", padding: "5px", borderRadius: "10px", margin: "10px", width: "210px", display: 'flex', alignItems: 'center' }} */}
                        <BuildCircleIcon
                            sx={{
                                color: "white",
                                marginRight: "5px",
                                animation: `${rotateAnimation} 5s linear infinite`
                            }}
                        />
                        <Typography variant="h6" sx={{ color: "white" }}>Machine Parameter</Typography>
                    </Box>
                </Grid>

                {visibleWinder && (
                    <Grid item md={0} marginRight={1}>
                        <Tooltip title="Winder Machine Parameters">
                            <Chip
                                // icon={<SortOutlinedIcon style={{ ...iconStyle, color: selectedChip === 'Combinations' ? colors.blueAccent[900] : '#b39ddb' }} />}
                                label="Winder Machine Parameters"
                                variant="outlined"
                                onClick={() => handleChipClick('Winder Machine Parameters', handleViewWinderDetails)}
                                style={selectedChip === 'Winder Machine Parameters' ? selectedChipStyle : unselectedChipStyle}
                            />
                        </Tooltip>
                    </Grid>
                )}

                {visibleDuplex && (
                    <Grid item md={0} marginRight={1}>
                        <Tooltip title="Duplex Machine Parameters">
                            <Chip
                                // icon={<StraightenOutlinedIcon style={{ ...iconStyle, color: selectedChip === 'Size Wise Achievements' ? colors.blueAccent[900] : '#dce775' }} />}
                                label="Duplex Machine Parameters"
                                variant="outlined"
                                onClick={() => handleChipClick('Duplex Machine Parameters', handleViewDuplexDetails)}
                                style={selectedChip === 'Duplex Machine Parameters' ? selectedChipStyle : unselectedChipStyle}
                            />
                        </Tooltip>
                    </Grid>
                )}

                {visibleSimplex && (
                    <Grid item md={0} marginRight={1}>
                        <Tooltip title="Simplex Cutter Parameters">
                            <Chip
                                // icon={<ShoppingCartCheckoutOutlinedIcon style={{ ...iconStyle, color: selectedChip === 'Line Item Wise Achievements' ? colors.blueAccent[900] : '#00e676' }} />}
                                label="Simplex Cutter Parameters"
                                variant="outlined"
                                onClick={() => handleChipClick('Simplex Cutter Parameters', handleViewSimplexDetails)}
                                style={selectedChip === 'Simplex Cutter Parameters' ? selectedChipStyle : unselectedChipStyle}
                            />
                        </Tooltip>
                    </Grid>
                )}
            </Grid>

            <CallAlertBar
                parentRollMsgOpen={deckleMatchingMsgOpen}
                setParentRollMsgOpen={setDeckleMatchingMsgOpen}
                parentRollSeverityvalue={deckleMatchingSeverityvalue}
                setParentRollSeverityvalue={setDeckleMatchingSeverityvalue}
                parentRollAlertTitleValue={deckleMatchingAlertTitleValue}
                setParentRollAlertTitleValue={setDeckleMatchingAlertTitleValue}
                parentRollMessageValue={deckleMatchingMessageValue}
                setParentRollMessageValue={setDeckleMatchingMessageValue}
            />


            {viewWinderDetail && (
                <Grid container padding={1} spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Card sx={{ backgroundColor: "transparent", borderRadius: "10px" }}>
                            <Box margin='10px 10px 10px 10px' display="flex" alignItems="center">
                                <Typography variant="h5">Winder Machine List</Typography>
                            </Box>

                            <Divider />
                            <CardContent>
                                <Box
                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"
                                  
                                    sx={{
                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                            color: `${colors.grey[100]} !important`,
                                        },

                                        padding:'0px'

                                    }}
                                >
                                    <DataGrid
                                        columnHeaderHeight={35}
                                        rowHeight={40}
                                        rows={winderDetail}
                                        columns={columns}
                                        slots={{ toolbar: GridToolbar }}
                                        slotProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 10,
                                                },
                                            },
                                        }}
                                        pageSizeOptions={[10]}
                                    />
                                </Box>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleNewButtonClick} // Correct handler function
                                    startIcon={<AddIcon />}
                                    sx={{ marginRight: 'auto', marginTop: '10px', textTransform: 'none' }}
                                >
                                    New
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Dialog
                        open={openWinder}
                        onClose={handleCloseWinderDialog}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: 0,
                                margin: '0px', // Adjust as needed
                            },
                        }}
                    >
                        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                            <Typography variant="h6" sx={{ marginBottom: "5px" }}>Add New Machine Details</Typography>
                        </DialogTitle>

                        <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>
                            <Grid container padding={1} spacing={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Machine code"
                                        fullWidth
                                        required
                                        value={newRowData.machine_code}
                                        onChange={(e) => handleNewRowChange('machine_code', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Machine name"
                                        fullWidth
                                        required
                                        value={newRowData.machine_name}
                                        onChange={(e) => handleNewRowChange('machine_name', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Deckle Width"
                                        type="number"
                                        fullWidth
                                        required
                                        value={newRowData.mindeckle}
                                        onChange={(e) => handleNewRowChange('mindeckle', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Deckle Width"
                                        type="number"
                                        fullWidth
                                        required
                                        value={newRowData.maxdeckle}
                                        onChange={(e) => handleNewRowChange('maxdeckle', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max No. of Circular Knives"
                                        type="number"
                                        fullWidth
                                        required
                                        value={newRowData.maxcircularknife}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                handleNewRowChange('maxcircularknife', value);
                                            }
                                        }}
                                        inputProps={{ step: 1 }}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min weight per combination"
                                        type="number"
                                        required
                                        fullWidth
                                        value={newRowData.minsetweight}
                                        onChange={(e) => handleNewRowChange('minsetweight', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Diameter"
                                        type="number"
                                        required
                                        fullWidth
                                        value={newRowData.mindiameter}
                                        onChange={(e) => handleNewRowChange('mindiameter', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Diameter"
                                        type="number"
                                        required
                                        fullWidth
                                        value={newRowData.maxdiameter}
                                        onChange={(e) => handleNewRowChange('maxdiameter', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min GSM on M/C"
                                        type="number"
                                        fullWidth
                                        value={newRowData.mingsm}
                                        onChange={(e) => handleNewRowChange('mingsm', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max GSM on M/C"
                                        type="number"
                                        fullWidth
                                        value={newRowData.maxgsm}
                                        onChange={(e) => handleNewRowChange('maxgsm', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Jumbo Roll Width"
                                        type="number"
                                        required
                                        fullWidth
                                        value={newRowData.jumborollwidth}
                                        onChange={(e) => handleNewRowChange('jumborollwidth', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Winder Allowance per Cut"
                                        type="number"
                                        fullWidth
                                        value={newRowData.allowance_per_cut}
                                        onChange={(e) => handleNewRowChange('allowance_per_cut', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Production capacity"
                                        type="number"
                                        fullWidth
                                        value={newRowData.production_capacity}
                                        onChange={(e) => handleNewRowChange('production_capacity', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Time Required to add knife (min)"
                                        type="number"
                                        fullWidth
                                        value={newRowData.tr_addknife}
                                        onChange={(e) => handleNewRowChange('tr_addknife', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Time Required to change knife (min)"
                                        type="number"
                                        fullWidth
                                        value={newRowData.tr_changeknife}
                                        onChange={(e) => handleNewRowChange('tr_changeknife', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Time Required to change parent roll (min)"
                                        type="number"
                                        fullWidth
                                        value={newRowData.tr_changeparentroll}
                                        onChange={(e) => handleNewRowChange('tr_changeparentroll', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Time Required to remove knife (min)"
                                        type="number"
                                        fullWidth
                                        value={newRowData.tr_removeknife}
                                        onChange={(e) => handleNewRowChange('tr_removeknife', e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleSaveOrEditRow(false)}
                                startIcon={<SaveIcon />}
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {winderDetail.map((row) => (
                        expandedRows[row.id] && (
                            <Box key={row.id} sx={{ padding: 1, backgroundColor: colors.primary[400], borderRadius: '8px' }}>
                                <>
                                    <Dialog
                                        open={openWinderEdit}
                                        onClose={handleCloseWinderEditDialog}
                                        PaperProps={{
                                            style: {
                                                position: 'absolute',
                                                top: 0,
                                                margin: '0px', // Adjust as needed
                                            },
                                        }}
                                    >
                                        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                                            <Typography variant="h6" sx={{ marginBottom: "5px" }}>Machine Details for {row.machine_name}</Typography>
                                        </DialogTitle>

                                        <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>

                                            <Grid container padding={1} spacing={2}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Machine code"
                                                        fullWidth
                                                        value={row.machine_no}
                                                        onChange={(e) => handleEditChange(row.id, 'machine_no', e.target.value)}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Machine name"
                                                        fullWidth
                                                        value={row.machine_name}
                                                        onChange={(e) => handleEditChange(row.id, 'machine_name', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.mindeckle}
                                                        onChange={(e) => handleEditChange(row.id, 'mindeckle', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxdeckle}
                                                        onChange={(e) => handleEditChange(row.id, 'maxdeckle', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max No. of Circular Knives"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxcircularknife}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                                handleEditChange(row.id, 'maxcircularknife', value);
                                                            }
                                                        }}
                                                        inputProps={{ step: 1 }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Weight per Combination"
                                                        type="number"
                                                        fullWidth
                                                        value={row.minsetweight}
                                                        onChange={(e) => handleEditChange(row.id, 'minsetweight', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Diameter"
                                                        type="number"
                                                        fullWidth
                                                        value={row.mindiameter}
                                                        onChange={(e) => handleEditChange(row.id, 'mindiameter', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Diameter"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxdiameter}
                                                        onChange={(e) => handleEditChange(row.id, 'maxdiameter', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min GSM on M/C"
                                                        type="number"
                                                        fullWidth
                                                        value={row.mingsm}
                                                        onChange={(e) => handleEditChange(row.id, 'mingsm', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max GSM on M/C"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxgsm}
                                                        onChange={(e) => handleEditChange(row.id, 'maxgsm', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Jumbo Roll Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.jumborollwidth}
                                                        onChange={(e) => handleEditChange(row.id, 'jumborollwidth', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Winder Allowance per Cut"
                                                        type="number"
                                                        fullWidth
                                                        value={row.allowance_per_cut}
                                                        onChange={(e) => handleEditChange(row.id, 'allowance_per_cut', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="production capacity"
                                                        type="number"
                                                        fullWidth
                                                        value={row.productioncapacity}
                                                        onChange={(e) => handleEditChange(row.id, 'productioncapacity', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Time Required to add knife (min)"
                                                        type="number"
                                                        fullWidth
                                                        value={row.time_required_to_add_knife}
                                                        onChange={(e) => handleEditChange(row.id, 'time_required_to_add_knife', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Time Required to change knife (min)"
                                                        type="number"
                                                        fullWidth
                                                        value={row.time_required_to_change_knife}
                                                        onChange={(e) => handleEditChange(row.id, 'time_required_to_change_knife', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Time Required to change parent roll (min)"
                                                        type="number"
                                                        fullWidth
                                                        value={row.time_required_to_change_parent_roll}
                                                        onChange={(e) => handleEditChange(row.id, 'time_required_to_change_parent_roll', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Time Required to remove knife (min)"
                                                        type="number"
                                                        fullWidth
                                                        value={row.time_required_to_remove_knife}
                                                        onChange={(e) => handleEditChange(row.id, 'time_required_to_remove_knife', e.target.value)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </DialogContent>

                                        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => handleEditClick(row.id)}
                                                startIcon={editRows[row.id] ? <SaveIcon /> : <EditIcon />}
                                            >
                                                {editRows[row.id] ? "Save" : "Edit"}
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            </Box>
                        )
                    ))}

                </Grid>
            )}

            {viewDuplexDetail && (
                <Grid container spacing={1} padding={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Card sx={{ backgroundColor: 'transparent', borderRadius: "10px" }}>
                            <CardHeader title="Duplex Machine List" />
                            <Divider />
                            <CardContent>
                                <Box
                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"
                                    // padding={1}
                                    sx={{
                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                            color: `${colors.grey[100]} !important`,
                                        },
                                        // borderLeft: "0", // Remove left border
                                        // borderRight: "0", // Remove right border
                                        // width: '100%',
                                    }}
                                >
                                    <DataGrid
                                        columnHeaderHeight={35}
                                        rowHeight={40}
                                        rows={duplexDetail}
                                        columns={Duplexcolumns}
                                        slots={{ toolbar: GridToolbar }}
                                        slotProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 10,
                                                },
                                            },
                                        }}
                                        pageSizeOptions={[10]}
                                    />
                                </Box>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleNewButtonClickDuplex} // Correct handler function
                                    startIcon={<AddIcon />}
                                    sx={{ marginRight: 'auto', marginTop: '10px', textTransform: 'none' }}
                                >
                                    New
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>

                    {isAddingNewRowDuplex && (
                        <Dialog
                            open={openDuplex}
                            onClose={handleCloseDuplexDialog}
                            PaperProps={{
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    margin: '0px', // Adjust as needed
                                },
                            }}
                        >

                            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                                <Typography variant="h6" sx={{ marginBottom: "5px" }}>Add New Duplex Details</Typography>
                            </DialogTitle>

                            <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>
                                <Grid container padding={1} spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Machine code"
                                            fullWidth
                                            required
                                            value={newRowDataDuplex.machine_no}
                                            onChange={(e) => handleNewRowChangeDuplex('machine_no', e.target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Machine Name"
                                            fullWidth
                                            required
                                            value={newRowDataDuplex.machine_name}
                                            onChange={(e) => handleNewRowChangeDuplex('machine_name', e.target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Min Deckle Width"
                                            type="number"
                                            fullWidth
                                            value={newRowDataDuplex.mindeckle}
                                            onChange={(e) => handleNewRowChangeDuplex('mindeckle', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Max Deckle Width"
                                            type="number"
                                            fullWidth
                                            value={newRowDataDuplex.maxdeckle}
                                            onChange={(e) => handleNewRowChangeDuplex('maxdeckle', e.target.value)}
                                        />
                                    </Grid>


                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Max No. of Circular Knives"
                                            type="number"
                                            fullWidth
                                            required
                                            value={newRowData.maxcircularknife}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                    handleNewRowChangeDuplex('maxcircularknife', value);
                                                }
                                            }}
                                            inputProps={{ step: 1 }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Min Weight per Combination"
                                            type="number"
                                            fullWidth
                                            value={newRowDataDuplex.minsetweight}
                                            onChange={(e) => handleNewRowChangeDuplex('minsetweight', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Max difference between both chopping sizes"
                                            type="number"
                                            fullWidth
                                            value={newRowDataDuplex.max_diff_btwn_both_chop_sze}
                                            onChange={(e) => handleNewRowChangeDuplex('max_diff_btwn_both_chop_sze', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            size="small"
                                            label="Jumbo Roll Width"
                                            type="number"
                                            fullWidth
                                            value={newRowDataDuplex.jumborollwidth}
                                            onChange={(e) => handleNewRowChangeDuplex('jumborollwidth', e.target.value)}
                                        />
                                    </Grid>


                                </Grid>
                            </DialogContent>

                            <DialogActions style={{ backgroundColor: theme.palette.background.default }}>

                                <Button
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleSaveOrEditRowDuplex(false)}
                                    startIcon={<SaveIcon />}
                                >
                                    Save
                                </Button>

                            </DialogActions>
                        </Dialog>
                    )}

                    {duplexDetail.map((row) => (
                        duplexexpandedRows[row.id] && (
                            <Box key={row.id} sx={{ padding: 1, backgroundColor: colors.primary[400], borderRadius: '8px' }}>
                                <>

                                    <Dialog
                                        open={openDuplexEdit}
                                        onClose={handleCloseDuplexEditDialog}
                                        PaperProps={{
                                            style: {
                                                position: 'absolute',
                                                top: 0,
                                                margin: '0px', // Adjust as needed
                                            },
                                        }}
                                    >
                                        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                                            <Typography variant="h6" sx={{ marginBottom: "5px" }}>Duplex Cutter Details for {row.machine_name}</Typography>

                                        </DialogTitle>

                                        <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>
                                            <Grid container padding={1} spacing={2}>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Machine code"
                                                        fullWidth
                                                        required
                                                        value={row.machine_no}
                                                        disabled
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Machine Name"
                                                        fullWidth
                                                        required
                                                        value={row.machine_name}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'machine_name', e.target.value)}
                                                    />
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.mindeckle}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'mindeckle', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxdeckle}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'maxdeckle', e.target.value)}
                                                    />
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max No. of Circular Knives"
                                                        type="number"
                                                        fullWidth
                                                        value={row.maxcircularknife}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                                handleEditChangeDuplex(row.id, 'maxcircularknife', value);
                                                            }
                                                        }}
                                                        inputProps={{ step: 1 }}
                                                    />
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Weight per Combination"
                                                        type="number"
                                                        fullWidth
                                                        value={row.minsetweight}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'minsetweight', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max difference between both chopping sizes"
                                                        type="number"
                                                        fullWidth
                                                        value={row.max_diff_btwn_both_chop_sze}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'max_diff_btwn_both_chop_sze', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Jumbo Roll Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.jumborollwidth}
                                                        onChange={(e) => handleEditChangeDuplex(row.id, 'jumborollwidth', e.target.value)}
                                                    />
                                                </Grid>


                                            </Grid>

                                        </DialogContent>

                                        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => handleEditClickDuplex(row.id)}
                                                startIcon={editRows[row.id] ? <SaveIcon /> : <EditIcon />}
                                            >
                                                {editRows[row.id] ? "Save" : "Edit"}
                                            </Button>

                                        </DialogActions>

                                    </Dialog>
                                </>
                            </Box>
                        )
                    ))}

                </Grid>

            )}

            {viewSimplexDetail && (
                <Grid container spacing={1} padding={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Card sx={{ backgroundColor: 'transparent', borderRadius: "10px" }}>
                            <CardHeader title="Simlex Cutter List" />
                            <Divider />
                            <CardContent>
                                <Box
                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"
                                    // padding={1}
                                    sx={{
                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                            color: `${colors.grey[100]} !important`,
                                        },

                                    }}
                                >
                                    <DataGrid
                                        columnHeaderHeight={35}
                                        rowHeight={40}
                                        rows={simplexDetail ?? []}
                                        columns={Simplexcolumns}
                                        slots={{ toolbar: GridToolbar }}
                                        slotProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 10,
                                                },
                                            },
                                        }}
                                        pageSizeOptions={[10]}
                                    />
                                </Box>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleNewButtonClickSimplex} // Correct handler function
                                    startIcon={<AddIcon />}
                                    sx={{ marginRight: 'auto', marginTop: '10px', textTransform: 'none' }}
                                >
                                    New
                                </Button>

                            </CardContent>
                        </Card>
                    </Grid>




                    <Dialog
                        open={openSimplex}
                        onClose={handleCloseSimplexDialog}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: 0,
                                margin: '0px', // Adjust as needed
                            },
                        }}
                    >
                        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                            <Typography variant="h6" sx={{ marginBottom: "5px" }}>Add New Simplex Details</Typography>

                        </DialogTitle>


                        <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>

                            <Grid container padding={1} spacing={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Cutter name"
                                        fullWidth
                                        required
                                        value={newRowDataSimplex.c_name}
                                        onChange={(e) => handleNewRowChangeSimplex('c_name', e.target.value)}
                                    />
                                </Grid>




                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max No. of Circular Knives"
                                        type="number"
                                        fullWidth
                                        required
                                        value={newRowDataSimplex.c_knives}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                handleNewRowChangeSimplex('c_knives', value);
                                            }
                                        }}
                                        inputProps={{ step: 1 }}
                                    />
                                </Grid>


                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Deckle Width"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.c_width_min}
                                        onChange={(e) => handleNewRowChangeSimplex('c_width_min', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Deckle Width"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.c_width}
                                        onChange={(e) => handleNewRowChangeSimplex('c_width', e.target.value)}
                                    />
                                </Grid>



                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Diameter"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.min_dia}
                                        onChange={(e) => handleNewRowChangeSimplex('min_dia', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Diameter"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.max_dia}
                                        onChange={(e) => handleNewRowChangeSimplex('max_dia', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Chopping Size"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.min_chopping_size}
                                        onChange={(e) => handleNewRowChangeSimplex('min_chopping_size', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Chopping Size"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.max_chopping_size}
                                        onChange={(e) => handleNewRowChangeSimplex('max_chopping_size', e.target.value)}
                                    />
                                </Grid>


                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Allowance Per Cut"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.allow_per_cut}
                                        onChange={(e) => handleNewRowChangeSimplex('allow_per_cut', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Maximum Number of Parent Cut"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.max_no_of_parent_cut}
                                        onChange={(e) => handleNewRowChangeSimplex('max_no_of_parent_cut', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Min Cutter Load"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.min_cutter_load}
                                        onChange={(e) => handleNewRowChangeSimplex('min_cutter_load', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        size="small"
                                        label="Max Cutter Load"
                                        type="number"
                                        fullWidth
                                        value={newRowDataSimplex.max_cutter_load}
                                        onChange={(e) => handleNewRowChangeSimplex('max_cutter_load', e.target.value)}
                                    />
                                </Grid>



                            </Grid>
                        </DialogContent>

                        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleSaveOrEditRowSimplex(false)}
                                startIcon={<SaveIcon />}
                            >
                                Save
                            </Button>
                        </DialogActions>

                    </Dialog>



                    {simplexDetail.map((row) => (
                        simplexexpandedRows[row.id] && (
                            <Box key={row.id} sx={{ padding: 1, backgroundColor: colors.primary[400], borderRadius: '8px' }}>
                                <>

                                    <Dialog
                                        open={openSimplexEdit}
                                        onClose={handleCloseSimplexEditDialog}
                                        PaperProps={{
                                            style: {
                                                position: 'absolute',
                                                top: 0,
                                                margin: '0px', // Adjust as needed
                                            },
                                        }}
                                    >

                                        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                                            <Typography variant="h6" sx={{ marginBottom: "5px" }}>Simplex Cutter Details for {row.c_name}</Typography>

                                        </DialogTitle>

                                        <DialogContent padding={15} style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>




                                            <Grid container padding={1} spacing={2}>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Cutter name"
                                                        fullWidth
                                                        disabled
                                                        required
                                                        value={row.c_name}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'c_name', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max No. of Circular Knives"
                                                        type="number"
                                                        fullWidth
                                                        value={row.c_knives}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d+$/.test(value) || value === "") { // Allow only digits or empty value
                                                                handleEditChangeSimplex(row.id, 'c_knives', value);
                                                            }
                                                        }}
                                                        inputProps={{ step: 1 }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.c_width_min}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'c_width_min', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Deckle Width"
                                                        type="number"
                                                        fullWidth
                                                        value={row.c_width}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'c_width', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Diameter"
                                                        type="number"
                                                        fullWidth
                                                        value={row.min_dia}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'min_dia', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Diameter"
                                                        type="number"
                                                        fullWidth
                                                        value={row.max_dia}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'max_dia', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Chopping Size"
                                                        type="number"
                                                        fullWidth
                                                        value={row.min_chopping_size}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'min_chopping_size', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Chopping Size"
                                                        type="number"
                                                        fullWidth
                                                        value={row.max_chopping_size}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'max_chopping_size', e.target.value)}
                                                    />
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Allowance Per Cut"
                                                        type="number"
                                                        fullWidth
                                                        value={row.allow_per_cut}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'allow_per_cut', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Maximum Number of Parent Cut"
                                                        type="number"
                                                        fullWidth
                                                        value={row.max_no_of_parent_cut}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'max_no_of_parent_cut', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Min Cutter Load"
                                                        type="number"
                                                        fullWidth
                                                        value={row.min_cutter_load}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'min_cutter_load', e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        size="small"
                                                        label="Max Cutter Load"
                                                        type="number"
                                                        fullWidth
                                                        value={row.max_cutter_load}
                                                        onChange={(e) => handleEditChangeSimplex(row.id, 'max_cutter_load', e.target.value)}
                                                    />
                                                </Grid>


                                            </Grid>
                                        </DialogContent>


                                        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => handleEditClickSimplex(row.id)}
                                                startIcon={editRows[row.id] ? <SaveIcon /> : <EditIcon />}
                                            >
                                                {editRows[row.id] ? "Save" : "Edit"}
                                            </Button>
                                        </DialogActions>

                                    </Dialog>

                                </>
                            </Box>
                        )
                    ))}

                </Grid>
            )}






        </>
    );


};

export default MachineParametersSettings;


